import StorageKeys from "../../../const/StorageKeys";
import { BranchConfigurationDetails } from "../../../model/home/BranchInfoModel";
import AppConfigService from "../../../service/app_config/AppConfigService";
import SessionStorage from "../../../service/storage/SessionStorage";
import UtilityHelper from "../../../service/utilities/UtilityHelper";
import HomeProvider from "../../home/HomeProvider";

const BranchSwitchSplashProvider = new (class SearchProvider {
  setupBranchTheme = async (branchId: string) => {
    if (UtilityHelper.isNotEmpty(branchId)) {
      const branchInfoResult = await HomeProvider.getBranchDetail(branchId);

      if (branchInfoResult != null) {
        const branchConfig: BranchConfigurationDetails =
          branchInfoResult.result?.branch_info?.branch_configuration_details ??
          {};

        SessionStorage.deleteValue(StorageKeys.home_branch_detail);
        this.applyBranchThemeConfig(branchConfig);
      }
    }
  };

  applyBranchThemeConfig = (branchConfig: BranchConfigurationDetails) => {
    if (Object.keys(branchConfig).length > 0) {
      const themeColor: string =
        AppConfigService.get("company_theme_color") ?? "";
      const themeFontColor: string =
        AppConfigService.get("company_theme_font_color") ?? "";

      if (themeColor !== branchConfig.company_theme_color) {
        console.log("updated - company_theme_color");
        AppConfigService.update(
          "company_theme_color",
          branchConfig.company_theme_color!
        );
      }
      if (themeFontColor !== branchConfig.company_theme_font_color) {
        console.log("updated - company_theme_font_color");
        AppConfigService.update(
          "company_theme_font_color",
          branchConfig.company_theme_font_color!
        );
      }
    }
  };
})();

export default BranchSwitchSplashProvider;
